var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","small":_vm.small,"color":"#25D366","title":"Enviar WhatsApp","loading":_vm.load},on:{"click":_vm.sendWpp}},[_c('v-icon',[_vm._v("fab fa-whatsapp")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }